import './numbers.scss'

const animateValue = (node, start, end, duration) => {
  if (!node.hasAttribute('data-numbers-animate')) return

  let startTimestamp = null
  const step = (timestamp) => {
    if (!startTimestamp) startTimestamp = timestamp

    const progress = Math.min((timestamp - startTimestamp) / duration, 1)
    const value = progress * (end - start) + start

    node.setAttribute('data-numbers-value', Number.isSafeInteger(end) ? Math.floor(value) : value.toFixed(2))

    if (progress < 1) {
      window.requestAnimationFrame(step)
    }
  }

  window.requestAnimationFrame(step)
  node.removeAttribute('data-numbers-animate')
}

const handleIntersection = (entries) => {
  entries.forEach((entry) => entry.isIntersecting && animateValue(entry.target, +0, +entry.target.dataset.numbersValue, 1500))
}

const initNumbers = () => {
  const numbers = document.querySelectorAll('[data-numbers-value]')

  const observer = new IntersectionObserver(handleIntersection, {
    root: document,
    rootMargin: '0px',
    threshold: 1.0,
  })

  numbers?.forEach((number) => observer.observe(number))
}

document.addEventListener('DOMContentLoaded', async function () {
  initNumbers()
})
